const config = {
  apiBaseUrl: "https://api.amazingflips.com",
};

export default config;
